export var SalesEnablementEventTypes;
(function (SalesEnablementEventTypes) {
    SalesEnablementEventTypes["RELOAD_CUSTOMIZE"] = "DXP_RELOAD_CUSTOMIZE";
    SalesEnablementEventTypes["IS_CUSTOMIZE_PAGE"] = "DXP_IS_CUSTOMIZE_PAGE";
    SalesEnablementEventTypes["IS_CHECKOUT_PAGE"] = "DXP_IS_CHECKOUT_PAGE";
    SalesEnablementEventTypes["REQUEST_SESSION_ID"] = "DXP_REQUEST_SE_SESSION_ID";
    SalesEnablementEventTypes["SESSION_ID"] = "DXP_SE_SESSION_ID";
    SalesEnablementEventTypes["WAS_INITIALIZED_WITH_STOCK"] = "DXP_REQUEST_WAS_INITIALIZED_WITH_STOCK";
    SalesEnablementEventTypes["INITIALIZED_WITH_STOCK"] = "DXP_WAS_INITIALIZED_WITH_STOCK";
    SalesEnablementEventTypes["REQUEST_FINANCE_FORM_INPUT"] = "DXP_REQUEST_SE_FINANCE_FORM_INPUT";
    SalesEnablementEventTypes["FINANCE_FORM_INPUT"] = "DXP_SE_FINANCE_FORM_INPUT";
    SalesEnablementEventTypes["SELECT_DEALER_OPTIONS"] = "DXP_SELECT_DEALER_OPTIONS";
})(SalesEnablementEventTypes || (SalesEnablementEventTypes = {}));
//# sourceMappingURL=SalesEnablementEventTypes.js.map